import { render, staticRenderFns } from "./PresencesHome.vue?vue&type=template&id=707b8dfa&scoped=true"
import script from "./PresencesHome.vue?vue&type=script&lang=js"
export * from "./PresencesHome.vue?vue&type=script&lang=js"
import style0 from "./PresencesHome.vue?vue&type=style&index=0&id=707b8dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b8dfa",
  null
  
)

export default component.exports